/**
 * User Portal BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface IncomeStatisticsResponse { 
    currentBalanceBtc: number;
    currentBalanceUsd: number;
    totalIncome: number;
    pendingBalance: number;
    averageDaily: number;
    averageDailyUsd: number;
}

